module.exports = "/static/assets/00cb48b561d398f7e9570ebaeba16211.gif";